// FILE HANDLING
export const CONVERT_WAV_AIFF = 'CONVERT_WAV_AIFF'
export const CUSTOM_DOWNLOAD_FILE_NAMES = 'CUSTOM_DOWNLOAD_FILE_NAMES'
export const INITIAL_IMPORT = 'INITIAL_IMPORT'
export const MANAGE_REPLACE_FILES = 'MANAGE_REPLACE_FILES'
export const MERGE_FUNCTION = 'MERGE_FUNCTION'
export const METADATA_EDITING = 'METADATA_EDITING'
export const NATIVE_TAGS = 'NATIVE_TAGS'
export const COLOR_INDICATORS = 'COLOR_INDICATORS'
export const ONGOING_DDEX = 'ONGOING_DDEX'
export const ONGOING_DDEX_VISIBLE = 'ONGOING_DDEX_VISIBLE'
export const STORE_HI_RES = 'STORE_HI_RES'
export const TRANSCODE_320K = 'TRANSCODE_320K'
export const UPLOAD_PREVIEW = 'UPLOAD_PREVIEW'
export const WATERMARKING = 'WATERMARKING'
export const ALBUMS = 'ALBUMS'
export const COPY_METADATA = 'COPY_METADATA'
export const AUTO_TAGGING_UNLIMITED = 'AUTO_TAGGING_UNLIMITED'
export const INSTANT_INSTRUMENTAL = 'INSTANT_INSTRUMENTAL'
export const INSTANT_INSTRUMENTAL_HIDDEN_OVERRIDE =
  'INSTANT_INSTRUMENTAL_HIDDEN_OVERRIDE'
export const INSTANT_INSTRUMENTAL_VISIBLE = 'INSTANT_INSTRUMENTAL_VISIBLE'
export const LYRIC_TRANSCRIPTION = 'LYRIC_TRANSCRIPTION'

// SHARING AND PRESENTATION
export const ADD_PLAYLIST_MESSAGE = 'ADD_PLAYLIST_MESSAGE'
export const ASSIGN_URL_TO_CONTACTS = 'ASSIGN_URL_TO_CONTACTS'
export const CLIENT_FACING_LIBRARY = 'CLIENT_FACING_LIBRARY'
export const LIVE_LIBRARIES = 'LIVE_LIBRARIES'
export const COPY_TRACKLIST = 'COPY_TRACKLIST'
export const COPY_URL = 'COPY_URL'
export const CUSTOM_FORMAT_SETTINGS = 'CUSTOM_FORMAT_SETTINGS'
export const CUSTOMIZABLE_PLAYLIST_DESIGN = 'CUSTOMIZABLE_PLAYLIST_DESIGN'
export const DISCO_FOOTER_REMOVED = 'DISCO_FOOTER_REMOVED'
export const EMAIL_CAMPAIGN_BUILDER = 'EMAIL_CAMPAIGN_BUILDER'
export const EMAIL_THROUGH_DISCO = 'EMAIL_THROUGH_DISCO'
export const EMAIL_THROUGH_DISCO_BUSINESSES = 'EMAIL_THROUGH_DISCO_BUSINESSES'
export const EMBEDDABLE_PLAYLISTS = 'EMBEDDABLE_PLAYLISTS'
export const FEATURE_ARTWORK_ON_PLAYLIST = 'FEATURE_ARTWORK_ON_PLAYLIST'
export const FULLY_FUNCTIONAL = 'FULLY_FUNCTIONAL'
export const INBOXES_WITH_UPLOAD_PAGES = 'INBOXES_WITH_UPLOAD_PAGES'
export const KILL_URLS = 'KILL_URLS'
export const MARKETING_MESSAGE_REMOVED = 'MARKETING_MESSAGE_REMOVED'
export const METADATA_ALIAS_BATCH_EDITING = 'METADATA_ALIAS_BATCH_EDITING'
export const METADATA_ALIAS_INDIVIDUAL_EDITING =
  'METADATA_ALIAS_INDIVIDUAL_EDITING'
export const METADATA_ALIAS_COMMENTS = 'METADATA_ALIAS_COMMENTS'
export const PASSWORD_PROTECTION = 'PASSWORD_PROTECTION'
export const PLAYLIST_SECURITY = 'PLAYLIST_SECURITY'
export const PLAYLIST_THEMES_LIMITED = 'PLAYLIST_THEMES_LIMITED'
export const PLAYLIST_THEMES_UNLIMITED = 'PLAYLIST_THEMES_UNLIMITED'
export const SECTIONS = 'SECTIONS'
export const SHAREABLE_CHANNELS = 'SHAREABLE_CHANNELS'
export const SHARED_CHANNELS = 'SHARED_CHANNELS'
export const SHARE_EMAIL_TEMPLATE_OPTIONS = 'SHARE_EMAIL_TEMPLATE_OPTIONS'
export const SHOW_LYRICS = 'SHOW_LYRICS'
export const STREAMING_ONLY_OPTION = 'STREAMING_ONLY_OPTION'
export const CUSTOM_INBOXES = 'CUSTOM_INBOXES'
export const URL_EXPIRY_DATE = 'URL_EXPIRY_DATE'
export const WHITELISTING = 'WHITELISTING'
export const SHOWCASES = 'SHOWCASES'
export const TRACK_NESTING = 'TRACK_NESTING'
export const TRACK_NESTING_DND = 'TRACK_NESTING_DND'
export const TRACK_NESTING_EXPORT = 'TRACK_NESTING_EXPORT'
export const TRACK_SHARING = 'TRACK_SHARING'
export const BRIEFS = 'BRIEFS'

// SEARCH AND ORGANIZATION
export const ADVANCED_SEARCH = 'ADVANCED_SEARCH'
export const BREADCRUMB_EXPLORER = 'BREADCRUMB_EXPLORER'
export const CHANNELS_LIMITED = 'CHANNELS_LIMITED'
export const CHANNELS_UNLIMITED = 'CHANNELS_UNLIMITED'
export const CUSTOM_FIELDS = 'CUSTOM_FIELDS'
export const CUSTOM_FIELDS_VISIBLE = 'CUSTOM_FIELDS_VISIBLE'
export const INDEXED_SEARCHABLE = 'INDEXED_SEARCHABLE'
export const PLAYLIST_TAGS = 'PLAYLIST_TAGS'
export const SUB_FOLDERS = 'SUB_FOLDERS'
export const TERRITORY_RESTRICTIONS = 'TERRITORY_RESTRICTIONS'
export const SIM_SEARCH = 'SIM_SEARCH'
export const AGGREGATED_SEARCH = 'AGGREGATED_SEARCH'
export const AIMS = 'AIMS'
export const NEW_SEARCH_MDS_ENABLE = 'NEW_SEARCH_MDS_ENABLE'
export const UNIFIED_SEARCH_ENABLE = 'UNIFIED_SEARCH_ENABLE'
export const SIMSEARCH_V2 = 'SIMSEARCH_V2'
export const PROMPT_SEARCH = 'PROMPT_SEARCH'
// Temporary flag hiding the search Indicators column until the project ships
export const SEARCH_INDICATORS_COLUMN_ENABLE = 'SEARCH_INDICATORS_COLUMN_ENABLE'

// CONTACT MANAGEMENT & ACCESS STATS
export const CONTACT_ACTIVITY_TAB = 'CONTACT_ACTIVITY_TAB'
export const CONTACT_CUSTOM_FIELDS = 'CONTACT_CUSTOM_FIELDS'
export const CONTACT_DATABASE_BASIC = 'CONTACT_DATABASE_BASIC'
export const CONTACT_NOTES = 'CONTACT_NOTES'
export const CONTACTS_DATABASE_UNLIMITED = 'CONTACTS_DATABASE_UNLIMITED'
export const MAILING_LISTS = 'MAILING_LISTS'
export const PLAYLIST_STATS_BASIC = 'PLAYLIST_STATS_BASIC'
export const PLAYLIST_STATS_WITH_HOVER = 'PLAYLIST_STATS_WITH_HOVER'

// ANALYTICS & REPORTS
export const ANALYTICS_LIMITED = 'ANALYTICS_LIMITED'
export const ANALYTICS_UNLIMITED = 'ANALYTICS_UNLIMITED'
export const EXPORT_REPORT_TO_PDF = 'EXPORT_REPORT_TO_PDF'
export const REPORTS_ADVANCED = 'REPORTS_ADVANCED'
export const REPORTS_BASIC = 'REPORTS_BASIC'

// ADMINISTRATION
export const ADMIN_PERMISSION_MANAGEMENT_BASIC_LEVEL =
  'ADMIN_PERMISSION_MANAGEMENT_BASIC_LEVEL'
export const ADMIN_PERMISSION_MANAGEMENT_MEDIUM_LEVEL =
  'ADMIN_PERMISSION_MANAGEMENT_MEDIUM_LEVEL'
export const ADMIN_PERMISSIONS_MANAGEMENT_ADVANCED =
  'ADMIN_PERMISSIONS_MANAGEMENT_ADVANCED'
export const CUSTOMIZED_DISCO_URL = 'CUSTOMIZED_DISCO_URL'
export const DEEP_SECURITY = 'DEEP_SECURITY'
export const INCLUDE_CONTACT_INFO = 'INCLUDE_CONTACT_INFO'
export const PLAYLIST_ORGANIZATION_EXPOSED = 'PLAYLIST_ORGANIZATION_EXPOSED'
export const SINGLE_SIGN_ON = 'SINGLE_SIGN_ON'
export const SELF_SERVE_PLAN_CHANGE = 'SELF_SERVE_PLAN_CHANGE'
export const SELF_SERVE_COMPONENTS_CHANGE = 'SELF_SERVE_COMPONENTS_CHANGE'
export const SELF_SERVE_ADDONS_CHANGE = 'SELF_SERVE_ADDONS_CHANGE'
export const SELF_SERVE_CANCELLATION = 'SELF_SERVE_CANCELLATION'

// SUPPORT
export const IS_SUBSCRIBER = 'IS_SUBSCRIBER'
export const DEDICATED_ACCOUNT_MANAGER = 'DEDICATED_ACCOUNT_MANAGER'
export const IN_PERSON_TRAINING = 'IN_PERSON_TRAINING'
export const MESSENGER_EXPRESS = 'MESSENGER_EXPRESS'
export const MESSENGER_PRIORITY = 'MESSENGER_PRIORITY'
export const MESSENGER_ROBO = 'MESSENGER_ROBO'
export const SCREENSHARE_TRAINING = 'SCREENSHARE_TRAINING'
export const TRAINING_VIDEO_ACCESS = 'TRAINING_VIDEO_ACCESS'
export const UNLIMITED_TRAINING = 'UNLIMITED_TRAINING'
export const IS_GBSTORAGE = 'IS_GBSTORAGE'

// ACTIVE PLAN CHECK
export const PLAN_ACTIVE = 'PLAN_ACTIVE'

// BROWSE LIBRARIES
export const BROWSE_LIBRARIES = 'BROWSE_LIBRARIES'

// LICENSE REQUEST
export const LICENSE_REQUEST = 'LICENSE_REQUEST'

// SECURE STREAMING
export const SESSION_BOUND_URLS = 'SESSION_BOUND_URLS'

export const PLAYLIST_THEMES_LIMIT_AMOUNT = 3

// ARTIST PLAN
export const IS_ARTIST = 'IS_ARTIST'
